const searchStore = {
  namespaced: true,
  state: () => ({
    choosedKbli: [],
    choosedIujp: [],
    choosedSbujk: [],
    choosedIujptl: [],
    choosedInubbm: [],
    choosedSiupal: [],

    chooseK3lScore: [],
    chooseKplhScore: [],

    chooseMine: null,
    chooseSio: null,

    location: '',
    vendorName: '',
  }),
  mutations: {
    SET_SEARCH_VALUE(state, payload) {
      console.log('payload: ', payload.name, payload.value)
      state[payload.name] = payload.value
    },
    RESET_FILTER_VALUE(state, payload) {
      state.choosedKbli = []
      state.choosedIujp = []
      state.choosedSbujk = []
      state.choosedIujptl = []
      state.choosedInubbm = []
      state.choosedSiupal = []

      state.chooseK3lScore = []
      state.chooseKplhScore = []

      state.chooseMine = null
      state.chooseSio = null

      state.location = ''
      state.vendorName = ''
    },
  },
  actions: {},
}

export default searchStore
